import { SafeCollector3ss0wp8n80f6m as SafeCollector } from './internal/SafeCollector.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractFlowClass;
function AbstractFlow() {
  if (AbstractFlowClass === VOID) {
    class $ {
      *y1c(collector, $completion) {
        // Inline function 'kotlin.js.getCoroutineContext' call
        var tmp$ret$0 = $completion.pc();
        var safeCollector = new (SafeCollector())(collector, tmp$ret$0);
        try {
          yield* this.x1c(safeCollector, $completion);
        }finally {
          safeCollector.zc();
        }
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'AbstractFlow', VOID, VOID, VOID, [1]);
    AbstractFlowClass = $;
  }
  return AbstractFlowClass;
}
//region block: exports
export {
  AbstractFlow as AbstractFlow3bixaw6q3bbim,
};
//endregion

//# sourceMappingURL=Flow.mjs.map
